navApp.directive('navitem', [
  '$compile', '_', 'templatePath', 'endpointDomain', 'NavStateService', 'updateHeight', function($compile, _, templatePath, endpointDomain, NavStateService, updateHeight) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'navitem.html',
      link: function(scope, element, attrs) {
        var hasCallout;
        scope.navStateService = NavStateService;
        scope.navkey = attrs['navkey'];
        scope.navlevel = (attrs['navlevel'] || 0) * 1 + 1;
        scope.hasChildren = angular.isArray(scope.item.children) && scope.item.children.length > 0;
        hasCallout = scope.navStateService.hasCallout(scope.item);
        scope.updateCallout = function() {
          if (hasCallout) {
            NavStateService.updateCallout(scope.navkey, scope.item);
            return updateHeight(element);
          }
        };
        scope.activateItem = function(item, e) {
          if (scope.hasChildren) {
            scope.navStateService.showItem(scope.navkey, scope.$id, scope.navlevel);
            return e.preventDefault();
          }
        };
        if (scope.hasChildren) {
          return $compile('<navcollection collection="item.children" ' + 'navlevel="' + scope.navlevel + '" ' + ' navkey="' + scope.navkey + '"></navcollection>')(scope, function(cloned) {
            return element.append(cloned);
          });
        }
      }
    };
  }
]);
